import { useSelector } from 'react-redux';

import { authUserSelector } from '../services/selectors';
import { User } from '../types';

const useUser = (): User => useSelector(authUserSelector);

export default useUser;
